import { OclParser } from './parser/OclParser.js';
import { Utils } from './Utils.js';
import { OclExecutionContext } from './OclExecutionContext.js';
import { OclResult } from './OclResult.js';
export class OclEngine {
    constructor() {
        this.packageDeclarations = [];
        this.registeredTypes = OclParser.registeredTypes;
        this.registeredEnums = OclParser.registeredEnums;
    }
    static create() {
        return new OclEngine();
    }
    setTypeDeterminer(fn) {
        if (typeof fn === 'function') {
            OclEngine.Utils.typeDeterminerFn = fn;
        }
    }
    registerTypes(types) {
        this.registeredTypes = Object.assign(Object.assign({}, this.registeredTypes), types);
        OclParser.registeredTypes = this.registeredTypes;
    }
    registerEnum(name, values) {
        this.registeredEnums = Object.assign(Object.assign({}, this.registeredEnums), { [name]: values });
        OclParser.registeredEnums = this.registeredEnums;
    }
    addOclExpressions(oclExpressions, labels = []) {
        oclExpressions.forEach(oclExpression => this.addOclExpression(oclExpression, labels));
        return this;
    }
    addOclExpression(oclExpression, labels = []) {
        try {
            const parsedExpression = OclEngine.Parser.parse(oclExpression, labels, this.registeredTypes);
            this.packageDeclarations.push(parsedExpression);
        }
        catch (e) {
            e.oclExpression = oclExpression;
            throw e;
        }
        return this;
    }
    removeOclExpression(oclExpression) {
        const parsedExpression = OclEngine.Parser.parse(oclExpression, [], this.registeredTypes);
        this.packageDeclarations = this.packageDeclarations.filter(packageDeclaration => {
            return Utils.hashCode(packageDeclaration.getRawOclExpression()) !== Utils.hashCode(oclExpression);
        });
        return this;
    }
    clearAllOclExpressions() {
        this.packageDeclarations.length = 0;
        return this;
    }
    evaluate(obj, labels = []) {
        const visitor = new OclExecutionContext(obj);
        visitor.registerTypes(this.registeredTypes);
        visitor.setRegisteredEnumerations(this.registeredEnums);
        this.packageDeclarations.forEach(e => e.evaluate(visitor));
        return new OclResult(visitor.getFailedInvariants()
            .map(inv => inv.getName()), visitor.getEvaluatedContexts());
    }
    _inferType(obj) {
        return Utils.getClassName(obj);
    }
    createQuery(oclExpression) {
        return OclEngine.Parser.parseQuery(oclExpression, this.registeredTypes);
    }
    evaluateQuery(obj, oclExpression) {
        const visitor = new OclExecutionContext(obj);
        visitor.registerTypes(this.registeredTypes);
        return oclExpression.evaluate(visitor);
    }
}
OclEngine.Utils = Utils;
OclEngine.Parser = OclParser;
//# sourceMappingURL=OclEngine.js.map